import React from 'react';
import { Modal, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { setLoginRequiredModalOpen } from '@/store/actions/cmme';
import { Button, CircleUserIcon, Label } from '@/components';
import { userAuthApi } from '@/endpoints/apiUrls';
import { toQueryParams } from '@/helpers';
import Analytics from '@/analytics';
import { ModalWrapperStyled, ModalBodyStyled, ModalFooterStyled } from './styles';

const LoginRequiredModal = () => {
  const dispatch = useDispatch();
  const webComponentConfing = useSelector((state) => state.cmmeReducer.config);

  const handleCancelClick = () => {
    dispatch(setLoginRequiredModalOpen(false));

    Analytics.linkInbound({ linkType: 'Cancel' });
  };

  const handleLogInClick = () => {
    const _realm = webComponentConfing.realm;
    const _locale = webComponentConfing.locale;
    const params = toQueryParams({ _realm, _locale });
    const linkUrl = userAuthApi.signinRedirect(params);

    window.location.href = linkUrl;

    Analytics.linkInbound({ linkUrl, linkType: 'Login' });
  };

  return (
    <Modal open>
      <ModalWrapperStyled>
        <ModalBodyStyled>
          <Box>
            <Box sx={{ marginTop: '20px', textAlign: 'center' }}>
              <CircleUserIcon />
            </Box>
            <Box sx={{ marginTop: '40px', marginBottom: '70px', textAlign: 'center' }}>
              <div style={{ marginBottom: '10px' }}>
                <Label variant="bold" fontSize={24}>
                  <FormattedMessage id="cmme.logInRequired" defaultMessage="Login is required" />
                </Label>
              </div>
              <div>
                <Label fontSize={18}>
                  <FormattedMessage id="cmme.logInToSaveProject" defaultMessage="Please log in to save the project" />
                </Label>
              </div>
            </Box>
          </Box>
        </ModalBodyStyled>

        <ModalFooterStyled>
          <Button variant="primary" onClick={handleCancelClick}>
            <FormattedMessage id="core.cancel" defaultMessage="Cancel" />
          </Button>
          <Button variant="secondary" onClick={handleLogInClick}>
            <FormattedMessage id="cmme.logIn" defaultMessage="Log in" />
          </Button>
        </ModalFooterStyled>
      </ModalWrapperStyled>
    </Modal>
  );
};

export default LoginRequiredModal;
